export const toSnakeCase = (value: string): string =>
  value
    .replace(/\W+/gu, ' ')
    .split(/ |\B(?=[A-Z])/u)
    .map((word) => word.toLowerCase())
    .join('_');
